import { Carousel, Select, Button, Card } from "antd";
import MainLayout from "../layouts/MainLayout";
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from "react-redux";
import { getSiteSettings } from "../redux/actions/siteSettings";
import { useEffect, useState } from "react";
import { getPost } from "../redux/actions/post";
import PostCard from "../components/PostCard";
import { getProducts } from "../redux/actions/product";
import ProductCard from "../components/ProductCard";
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
const Home = () => {
  const { siteSettings } = useSelector((state: any) => state.siteSettings);
  const { posts } = useSelector((state: any) => state.posts);
  const { products } = useSelector((state: any) => state.products);

  const slides = siteSettings?.slides;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useState({
    brand: '',
    width: '',
    height: '',
    diameter: '',
    season: ''
  });

  useEffect(() => {
    dispatch<any>(getSiteSettings());
    dispatch<any>(getPost());
    // Ana sayfada kış lastiklerini göster
    dispatch<any>(getProducts({ season: ['Kış'], limit: 20 }));
  }, [dispatch]);

  const handleSearch = () => {
    const params = new URLSearchParams();

    // Marka filtresi
    if (searchParams.brand) {
      params.append('brand', searchParams.brand);
    }

    // Lastik ebatı kontrolü
    const hasWidth = searchParams.width;
    const hasHeight = searchParams.height;
    const hasDiameter = searchParams.diameter;

    // Tam ebat varsa (genişlik/yükseklik/R+jant)
    if (hasWidth && hasHeight && hasDiameter) {
      const tireSize = `${searchParams.width}/${searchParams.height}/R${searchParams.diameter}`;
      params.append('tire_size', tireSize);
    }
    // Kısmi ebat varsa search parametresi olarak gönder
    else if (hasWidth || hasHeight || hasDiameter) {
      let searchQuery = '';
      if (hasWidth) searchQuery += searchParams.width;
      if (hasHeight) searchQuery += (searchQuery ? '/' : '') + searchParams.height;
      if (hasDiameter) searchQuery += (searchQuery ? '/R' : 'R') + searchParams.diameter;
      params.append('search', searchQuery);
    }

    // Sezon filtresi
    if (searchParams.season) {
      params.append('season', searchParams.season);
    }

    // Parametreler varsa lastik sayfasına yönlendir
    if (params.toString()) {
      navigate(`/lastik?${params.toString()}`);
    } else {
      navigate('/lastik');
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true
  };

  const responsive = [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3.2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10px'
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10px'
      }
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10px'
      }
    }
  ]

  console.log(posts);

  return (
    <MainLayout>
      <Helmet>
        <title>Sakarya Lastik - Lastik Fiyatları, Online Lastik Satışı ve Montaj Hizmeti</title>
        <meta name="description" content="Sakarya'nın en güvenilir lastik satış ve montaj merkezi. Otomobil, kamyon, iş makinesi lastikleri uygun fiyatlarla. Ücretsiz kargo ve profesyonel montaj hizmeti. Michelin, Bridgestone, Continental, Pirelli ve tüm markalar." />
        <meta name="keywords" content="sakarya lastik, lastik fiyatları, online lastik satışı, lastik montaj, otomobil lastiği, kamyon lastiği, iş makinesi lastiği, kış lastiği, yaz lastiği, michelin lastik, bridgestone lastik, continental lastik, pirelli lastik, uygun lastik, kaliteli lastik" />

        {/* Open Graph */}
        <meta property="og:title" content="Sakarya Lastik - Lastik Fiyatları ve Online Satış" />
        <meta property="og:description" content="Tüm lastik ihtiyaçlarınız için güvenilir adres. Ücretsiz kargo, profesyonel montaj ve uygun fiyatlar." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sakaryalastik.com" />
        <meta property="og:site_name" content="Sakarya Lastik" />

        {/* Canonical */}
        <link rel="canonical" href="https://sakaryalastik.com/" />

        {/* Additional SEO */}
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="Sakarya Lastik" />
        <meta name="geo.region" content="TR-54" />
        <meta name="geo.placename" content="Sakarya" />
      </Helmet>

      {/* Organization Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "TireShop",
          "name": "Sakarya Lastik",
          "description": "Lastik satışı, montaj ve bakım hizmetleri",
          "url": "https://sakaryalastik.com",
          "logo": "https://sakaryalastik.com/images/logo.webp",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Sakarya",
            "addressRegion": "Sakarya",
            "addressCountry": "TR"
          },
          "telephone": "+90-543-878-3435",
          "priceRange": "₺₺",
          "openingHours": "Mo-Su 08:00-20:00",
          "sameAs": [
            "https://instagram.com/altunotolastik",
            "https://www.facebook.com/profile.php?id=100032739833072"
          ]
        })}
      </script>

      {/* WebSite Structured Data with Search */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Sakarya Lastik",
          "url": "https://sakaryalastik.com",
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": "https://sakaryalastik.com/lastik?search={search_term_string}"
            },
            "query-input": "required name=search_term_string"
          }
        })}
      </script>

      {/* SEO için gizli H1 */}
      <h1 className="sr-only">
        Sakarya Lastik - Online Lastik Satışı, Lastik Fiyatları ve Montaj Hizmeti
      </h1>

      {
        siteSettings && <div className="hidden md:block">
          <Carousel {...settings} className="shadow-xl drop-shadow-2xl">
            {
              slides?.map((item: any, index: number) => {
                // PNG/JPG uzantılarını WebP'ye çevir
                const webpImage = item.replace(/\.(png|jpg|jpeg|gif)$/i, '.webp');
                return (
                  <div key={index}>
                    <img src={webpImage} alt={`Slide ${index + 1}`} />
                  </div>
                );
              })
            }
          </Carousel>
        </div>
      }

      {/* Professional Search Engine */}
      <div className="container mx-auto px-4 -mt-5 relative">
        <Card className="shadow-2xl border-none rounded-2xl overflow-hidden relative">
          {/* Background with car tire image */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: 'url(/images/araba-lastik-bg.webp)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'grayscale(100%) brightness(0.4)',
              opacity: 0.8
            }}
          ></div>

          {/* Dark overlay for better text contrast */}
          <div className="absolute inset-0 bg-gradient-to-br from-purple-900/60 via-indigo-900/50 to-purple-900/60"></div>

          <div className="relative">
            <div className="text-center">
              <h2 className="text-3xl font-bold text-white mb-2 drop-shadow-lg">🔍 Lastik Ara</h2>
              <p className="text-gray-100 text-lg">Size uygun lastiği kolayca bulun</p>
            </div>

            <div className="bg-transparent backdrop-blur-sm rounded-xl shadow-xl">
              <div className="grid grid-cols-1 lg:grid-cols-6 gap-4">
                {/* Marka */}
                <div className="lg:col-span-2">
                  <label htmlFor="brand-select" className="block text-sm font-semibold text-white mb-2">Marka</label>
                  <Select
                    id="brand-select"
                    placeholder="Marka seçin"
                    size="large"
                    className="w-full"
                    value={searchParams.brand || undefined}
                    onChange={(value) => setSearchParams({ ...searchParams, brand: value })}
                    allowClear
                    aria-label="Marka seçin"
                  >
                    <Option value="Michelin">Michelin</Option>
                    <Option value="Bridgestone">Bridgestone</Option>
                    <Option value="Goodyear">Goodyear</Option>
                    <Option value="Continental">Continental</Option>
                    <Option value="Pirelli">Pirelli</Option>
                    <Option value="Petlas">Petlas</Option>
                    <Option value="Lassa">Lassa</Option>
                    <Option value="Kumho">Kumho</Option>
                    <Option value="Hankook">Hankook</Option>
                    <Option value="Dunlop">Dunlop</Option>
                    <Option value="Waterfall">Waterfall</Option>
                  </Select>
                </div>

                {/* Genişlik, Yükseklik, Jant - 3 columns on mobile, single columns on desktop */}
                <div className="grid grid-cols-3 gap-2 lg:contents">
                  {/* Genişlik */}
                  <div className="lg:col-span-1">
                    <label htmlFor="width-select" className="block text-xs md:text-sm font-semibold text-white mb-2">Genişlik</label>
                    <Select
                      id="width-select"
                      placeholder="Genişlik"
                      size="large"
                      className="w-full"
                      value={searchParams.width || undefined}
                      onChange={(value) => setSearchParams({ ...searchParams, width: value })}
                      showSearch
                      allowClear
                      aria-label="Lastik genişliği"
                    >
                      {['155', '165', '175', '185', '195', '205', '215', '225', '235', '245', '255', '265', '275', '285', '295'].map(w => (
                        <Option key={w} value={w}>{w}</Option>
                      ))}
                    </Select>
                  </div>

                  {/* Yükseklik */}
                  <div className="lg:col-span-1">
                    <label htmlFor="height-select" className="block text-xs md:text-sm font-semibold text-white mb-2">Yükseklik</label>
                    <Select
                      id="height-select"
                      placeholder="Yükseklik"
                      size="large"
                      className="w-full"
                      value={searchParams.height || undefined}
                      onChange={(value) => setSearchParams({ ...searchParams, height: value })}
                      showSearch
                      allowClear
                      aria-label="Lastik yüksekliği"
                    >
                      {['35', '40', '45', '50', '55', '60', '65', '70', '75', '80'].map(h => (
                        <Option key={h} value={h}>{h}</Option>
                      ))}
                    </Select>
                  </div>

                  {/* Jant */}
                  <div className="lg:col-span-1">
                    <label htmlFor="diameter-select" className="block text-xs md:text-sm font-semibold text-white mb-2">Jant (R)</label>
                    <Select
                      id="diameter-select"
                      placeholder="Jant"
                      size="large"
                      className="w-full"
                      value={searchParams.diameter || undefined}
                      onChange={(value) => setSearchParams({ ...searchParams, diameter: value })}
                      showSearch
                      allowClear
                      aria-label="Jant çapı"
                    >
                      {['13', '14', '15', '16', '17', '18', '19', '20', '21', '22'].map(d => (
                        <Option key={d} value={d}>{d}</Option>
                      ))}
                    </Select>
                  </div>
                </div>

                {/* Mevsim */}
                <div className="lg:col-span-1">
                  <label htmlFor="season-select" className="block text-sm font-semibold text-white mb-2">Mevsim</label>
                  <Select
                    id="season-select"
                    placeholder="Mevsim"
                    size="large"
                    className="w-full"
                    value={searchParams.season || undefined}
                    onChange={(value) => setSearchParams({ ...searchParams, season: value })}
                    allowClear
                    aria-label="Mevsim seçin"
                  >
                    <Option value="Yaz">Yaz</Option>
                    <Option value="Kış">Kış</Option>
                    <Option value="4 Mevsim">4 Mevsim</Option>
                  </Select>
                </div>
              </div>

              {/* Search Button */}
              <div className="mt-6 text-center">
                <Button
                  type="primary"
                  size="large"
                  icon={<SearchOutlined />}
                  onClick={handleSearch}
                  className="bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 border-none px-12 h-12 text-lg font-semibold shadow-lg"
                >
                  Lastik Ara
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* Elektrikli Araç Banner */}
      <div className="container mx-auto px-4 my-16">
        <div className="bg-gradient-to-r from-purple-600 via-blue-600 to-purple-600 rounded-2xl shadow-2xl overflow-hidden">
          <div className="grid md:grid-cols-2 gap-8 items-center p-8 md:p-12">
            <div className="text-white">
              <div className="inline-block bg-yellow-400 text-purple-900 px-4 py-2 rounded-full text-sm font-bold mb-4">
                ⚡ YENİ REHBERİMİZ
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Elektrikli Araç Lastiği Değiştirme Rehberi
              </h2>
              <p className="text-xl text-purple-100 mb-6">
                Tesla, BMW i3, Mercedes EQC ve tüm elektrikli araçlar için güvenli lastik değişimi prosedürleri
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center text-purple-100">
                  <span className="bg-green-400 text-white rounded-full p-1 mr-3">✓</span>
                  Kritik Güvenlik Uyarıları
                </li>
                <li className="flex items-center text-purple-100">
                  <span className="bg-green-400 text-white rounded-full p-1 mr-3">✓</span>
                  Adım Adım Kaldırma Prosedürü
                </li>
                <li className="flex items-center text-purple-100">
                  <span className="bg-green-400 text-white rounded-full p-1 mr-3">✓</span>
                  Pil Paketi Koruma Yöntemleri
                </li>
                <li className="flex items-center text-purple-100">
                  <span className="bg-green-400 text-white rounded-full p-1 mr-3">✓</span>
                  Profesyonel Tavsiyeler
                </li>
              </ul>
              <a
                href="/elektrikli-arac-lastik-rehberi"
                className="inline-block bg-white text-purple-700 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 hover:text-purple-900 transition-all shadow-lg transform hover:scale-105"
              >
                Rehberi İncele →
              </a>
            </div>
            <div className="relative hidden md:block">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border-2 border-white/20">
                <div className="text-center mb-4">
                  <span className="text-6xl">⚡</span>
                  <h3 className="text-white text-2xl font-bold mt-2">Güvenli Lastik Değişimi</h3>
                </div>
                <div className="space-y-3">
                  <div className="bg-white/20 rounded-lg p-3 backdrop-blur">
                    <p className="text-white font-semibold">🔋 Batarya Koruması</p>
                    <p className="text-purple-100 text-sm">Yanlış kaldırma pil hasarına neden olabilir</p>
                  </div>
                  <div className="bg-white/20 rounded-lg p-3 backdrop-blur">
                    <p className="text-white font-semibold">⚙️ Doğru Kaldırma Noktaları</p>
                    <p className="text-purple-100 text-sm">Üretici onaylı prosedürler</p>
                  </div>
                  <div className="bg-white/20 rounded-lg p-3 backdrop-blur">
                    <p className="text-white font-semibold">✅ Uzman Desteği</p>
                    <p className="text-purple-100 text-sm">Profesyonel hizmet garantisi</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto !mt-20">
        <div className="justify-center mb-20">
          <div className="col-lg-6"><div className="title-area text-center">
            <span className="sub-title">Tamir ve Bakım Süreçlerimiz</span>
            <h2 className="sec-title">Güvenilir Araç Lastik Tamirinde En İyi Çözümler</h2>
          </div>
          </div>
        </div>
        <div className="flex flex-wrap">
          <div className="col-lg-4 process-card-wrap">
            <div className="process-card">
              <div className="process-card-icon">
                <img src="/images/process-icon-1-1.svg" alt="Altun Oto Lastik" />
              </div><h2 className="process-card-title">Mobil Lastik Tamiri</h2>
              <p className="process-card-text">7/24 Adapazarı, Sapanca, Kocaeli ve Kuzey Marmara Oto Yolu civarlarında size hizmete hazırız.</p>
            </div>
          </div>
          <div className="col-lg-4 process-card-wrap">
            <div className="process-card process-card-center">
              <div className="process-card-icon">
                <img src="/images/process-icon-1-2.svg" alt="Altun Oto Lastik" />
              </div>
              <h2 className="process-card-title">Profesyonel Ekip ve Ustalarımız</h2>
              <p className="process-card-text">Profesyonel ve Deneyimli ekibimiz size en kısa sürede ulaşıp, modern ve teknolojik ekipmanlarımızla en kısa sürede sizi yolunuza uğurlayacaktır.</p>
            </div>
          </div>
          <div className="col-lg-4 process-card-wrap"><div className="process-card">
            <div className="process-card-icon">
              <img src="/images/process-icon-1-3.svg" alt="Altun Oto Lastik" />
            </div>
            <h2 className="process-card-title">Sakarya İş Makinası Lastikleri</h2>
            <p className="process-card-text">Ağır Vasıta araçlarınız için lastik tamiri ve değişim işlemlerini 7/24 hizmet prensibiyle gerçekleştiriyoruz. Aradığınız lastiğin özellikleri ve lastik fiyatları hakkında bilgi alabilirsiniz.</p>
          </div>
          </div>
        </div>
        <h1 className="text-2xl font-bold mt-10 ">Blog | <small>Son Güncellemelerimizden Haberdar Olun</small></h1>
        <div className="mt-5">
          <Carousel
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={5}
            slidesToScroll={1}
            autoplay={false}
            autoplaySpeed={5000}
            arrows={true}
            responsive={responsive}
          >
            {posts?.map((item: any, index: number) => (
              <div key={index} className="px-2 mb-5 pb-5">
                <PostCard post={item} />
              </div>
            ))}
          </Carousel>
        </div>
        <h1 className="text-2xl font-bold mt-10 ">❄️ Kış Lastikleri | <small>Güvenli Sürüş İçin En İyi Seçenekler</small></h1>
        <div className="mt-5">
          <Carousel
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={5}
            slidesToScroll={1}
            autoplay={false}
            autoplaySpeed={5000}
            arrows={true}
            responsive={responsive}
          >
            {products?.map((item: any, index: number) => (
              <div key={index} className="px-2 mb-5">
                <ProductCard product={item} />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </MainLayout>
  );
}

export default Home;